"use client";

import {
  getCookieCategoryLabels,
  getCookieInventory,
  getCookieTableLabels,
  type CookieInventoryCategory,
} from "@/lib/cookie-consent/inventory";
import { showCookiePreferences } from "@/lib/cookie-consent/runtime";
import { useLocale, useTranslations } from "@/lib/i18n/provider";

const CATEGORY_ORDER: CookieInventoryCategory[] = [
  "necessary",
  "analytics",
  "marketing",
];

const CookieDeclaration = () => {
  const locale = useLocale();
  const t = useTranslations();
  const inventory = getCookieInventory(locale);
  const categoryLabels = getCookieCategoryLabels(locale);
  const tableLabels = getCookieTableLabels(locale);

  return (
    <section className="py-10">
      <div className="mb-4 flex flex-wrap items-center justify-between gap-3">
        <h1 className="text-3xl font-bold text-foreground">
          {tableLabels.title}
        </h1>
        {/* Where the cookie policy says consent can be changed or withdrawn. */}
        <button
          type="button"
          aria-haspopup="dialog"
          onClick={showCookiePreferences}
          className="rounded-lg border border-border px-4 py-2 text-sm font-medium text-foreground transition-colors hover:bg-muted/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring"
        >
          {t("cookies.settings")}
        </button>
      </div>
      <div className="overflow-x-auto rounded-md border border-border">
        <table className="min-w-full divide-y divide-border text-left text-sm">
          <thead className="bg-muted/40 text-muted-foreground">
            <tr>
              <th className="px-4 py-3 font-semibold">{tableLabels.category}</th>
              <th className="px-4 py-3 font-semibold">{tableLabels.name}</th>
              <th className="px-4 py-3 font-semibold">{tableLabels.provider}</th>
              <th className="px-4 py-3 font-semibold">{tableLabels.purpose}</th>
              <th className="px-4 py-3 font-semibold">{tableLabels.duration}</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {CATEGORY_ORDER.flatMap((category) =>
              inventory.filter((item) => item.category === category).map(
                (item) => (
                  <tr key={`${item.category}-${item.name}`}>
                    <td className="whitespace-nowrap px-4 py-3 font-medium text-foreground">
                      {categoryLabels[item.category]}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 font-mono text-xs text-foreground">
                      {item.name}
                    </td>
                    <td className="px-4 py-3 text-muted-foreground">
                      {item.provider}
                    </td>
                    <td className="px-4 py-3 text-muted-foreground">
                      {item.purpose}
                    </td>
                    <td className="whitespace-nowrap px-4 py-3 text-muted-foreground">
                      {item.duration}
                    </td>
                  </tr>
                )
              )
            )}
          </tbody>
        </table>
      </div>
    </section>
  );
};

export default CookieDeclaration;
